import {WidgetType} from "./WidgetManager/WEnum";

export enum PageMode {
	mmaathletes = 'mmaathletes',
	mmaresults = 'mmaresults',
	mmarefereeing = 'mmarefereeing',
	mmahighlights = 'mmahighlights',
	gamepadMMA = 'gamepadMMA',
	gamepadkb = 'gamepadkb',
	mmaevents = 'mmaevents',
	kbevents = 'kbevents',
	kbhighlights = 'kbhighlights',
	mmarating = 'mmarating',
	bookmaker = 'bookmaker',

	trainers = 'trainers',

	kickboxers = 'kickboxers',
	kbbouts = 'kbbouts',

	boxers = 'boxers',
	boxresults = 'boxresults',
	boxevents = 'boxevents',
	boxrefereeing = 'boxrefereeing',
	gamepad = 'gamepad',
	gamepad2 = 'gamepad2',
	states = 'states',
	mmastates = 'mmastates',

	fantasy = 'fantasy',
	newssource = 'newssource',
	videosource = 'videosource',
	cardsfantasy = 'cardsfantasy',
	widgets = 'widgets',

	tournaments = 'tournaments',
	users = 'users',
	players = 'players',
	player_achievements = 'player_achievements',
	players_rating = 'players_rating',
	novice_bots = 'novice_bots',
	payment_bot = 'payment_bot',
	push = 'push',
	promocodes = 'promocodes',
	teams = 'teams',
	collection = 'collection',
	pack_collection = 'pack_collection',
	fighter_cards_v2_special = 'fighter_cards_v2_special',
	siteufcrankings = 'siteufcrankings',
	special_bundles = 'special_bundles',
}


export enum SportType {
	MMA = 'MMA', Box = 'Box', KB = 'KB'
}

export function getSportType(pageMode: PageMode)
{
	switch (pageMode)
	{
		case PageMode.kbevents:
		case PageMode.kickboxers:
		case PageMode.kbbouts:
		case PageMode.mmastates:
		case PageMode.kbhighlights:
			return SportType.KB;

		case PageMode.boxevents:
		case PageMode.states:
		case PageMode.boxresults:
		case PageMode.boxers:
			return SportType.Box;
	}
	return SportType.MMA;
}

export enum Stage {
	Maincard = "Maincard",
	Statistics = "Statistics",
	Prelims = "Prelims",
	EarlyPrelims = "EarlyPrelims",
	Final = "Final",
	Stage_32 = "1/32",
	Stage_16 = "1/16",
	Stage_8 = "1/8",
	Stage_4 = "1/4",
	Stage_2 = "1/2"
}

export interface Trainer {
	Id: number,
	FirstName: string,
	LastName: string,
	Region: string,
	RegionId: string,
	Club: string,
	About: string,
	PhotoUrl: string
	BirthDate: string,
	Education: string,
	WorkStartDate: string,
	Achievements: string,
	Category: string,
	AthleteCount: number
}


export interface IAthlete {
	FlagUrl: string;
	AvatarUrl: string;
	PhotoUrl: string;
	Stance: string;
	LastNameRU: string;
	FirstNameRU: string;
	SiteFirstNameRU?: string;
	SiteLastNameRU?: string;
	Nickname: string,
	Id: number,
	Points: number,
	FirstName: string,
	LastName: string,
	DateBirth: string,
	WeightCategory: number,
	Weight: string;
	Sex: number,
	Region: string,
	State: string,
	City: string,
	SportCategory: string,
	SportClub: string
	TapologyUrl?: string;
	SherdogUrl?: string;
	UfcUrl?: string;
	EspnUrl?: string;
	Rating: number,
	StateIds: number[],
	RegionIds: number[],
	CountryId?: number,
	CountryName: string,
	CountryISO?: string,
	K: number,
	TournamentIds: number[],
	XKO: number,
	YKO: number,
	TotalLessThan6: number,
	TotalMoreThan6: number,
	Total12: number,
	BoutsCount: number,
	SportType: SportType,

	Height: string;

	ArmSpan: string;

	WinRecord: number;

	DrawRecord: number;

	LoseRecord: number;

	BaseStyle: string;

	GloryFighterID: string,

	TrainerId: number,

	AthleteRating: AthleteRating
}


export interface AthleteRating {

	force: number

	speed: number

	takedown: number

	control: number

	defense: number

	efficiency: number

	total: number

	totalRecord: number

	winCount: number

	loseCount: number

	drawCount: number
}

export interface IBattle {
	VideoUrl: string;
	VideoStartTime: string,
	RelativeVideoStartTime: string,
	Points: number;
	Id: number,
	Name: string;
	Red: number,
	Blue: number,
	RedGloryFighterID: string,
	BlueGloryFighterID: string,
	Winner: number,
	TournamentId: number,
	WinDescription: string,
	EventInfo: string,
	EventId: number,
	GloryFightID: string,
	RedName: string,
	BlueName: string,
	WinnerName: string,
	WeightId: number,
	Stage: string,
	Tournament: string,
	Date: string,
	Createts: string,
	Sex: number,
	WinType: string,
	RedPoints: number,
	BluePoints: number,
	RoundCount: number,
	RoundLength: number,
	Status: string,
	StartTime: string,
	EndTime: string,
	Type: SportType,
	WinRound: number,
	HLUrl_Full: string
	HLUrl_Short: string
	HLUrl_Optimal: string
}

export interface EventTournament {
	Id: number
	TournamentId: number
	Name: string,

	BattleCount: number,
	TournamentName: string,
	Date: string,
	DateStr: string,

	LocationId: number,
	GloryEventID: string,
	VideoFilePath: string
	HLUrl_Full: string
	HLUrl_Short: string
	HLUrl_Optimal: string
	VideoStreamUrl: string
	TVStreamUrl: string
	/** Site poster URL (768×512), TZ 9.3 */
	PosterUrl?: string | null
	/** TZ 9.1 — hide from statsfight.com / sitemap when true */
	SiteNoIndex?: boolean | null
}


export interface Location {
	Id: number,
	Name: string,
	CountryId: number,
	City: string,
	State: string,
	Country: string
}

export type MMAEvent = {
	Round: number;
	BattleId: number
	GroundStart?: string;
	GroundEnd?: string;
	Zone?: string;
	ActionAthleteId?: number;
	AnswerAthleteId?: number;
	GrappleEnd?: string;
	GrappleStart?: string;
	Action?: string;
	Answer?: string;
	IsSaved?: boolean;
	EventOrder?: number;
	Time?: string;
	ActionTS?: string
	Favorite?: number

	CustomOrder: number
}


export interface HighlightRow extends MMAEvent {
	HLDesc: string;
	HighlightTS: string;
	HLTime: string;
	AutoPoint: number;
	ManualPoint: number;
	IsReversal: boolean
	Is3punch2Sec: boolean,
	SegmentFileName: string
	TimeInfo: VideoSegmentInfo
}

export interface FunnyItem {
	Action: string,
	AthleteId: number,
	HLTime: string,
	HighlightTS: string,
	HighlightDate: string,
	BattleId: number
	Round: number,
	Id: number
	TimeInfo: VideoSegmentInfo,

	CustomOrder: number
}

export interface VideoSegmentInfo {
	PrevSeconds: number
	NextSeconds: number
}

export interface RecordData {
	Date: string
	Result: string
	Opponent: string
	WinType: string
	EndTime: string
	Round: number
}

export interface WidgetMetadata {
	WId: WidgetType
}

export interface EventStatWidgetMetadata extends WidgetMetadata {
	SponsorLogo: string
	PromoLogo: string
	Background: string
	EventId: number
	EventName: string
	TournamentName: string
	TournamentId: number
}

export interface Widget<M extends WidgetMetadata> {
	Id: number
	UrlId: string
	Name: string
	Metadata: M,
	Created: string
}

export interface FighterStatWidgetMetadata extends WidgetMetadata {
	FighterId: number
	EventId: number
	LastN: number
	Background: string,
	PeriodType: string
	FontFamily: string
	FontColor: string
	PhotoUrl: string
	FighterName: string
	Name: string
	LogoLeftTop: string
	LogoRightBottom: string
}

export interface FighterRecordWidgetMetadata extends WidgetMetadata {
	FighterId: number
	Background: string
	FontFamily: string
	FontColor: string
	PhotoUrl: string
	FighterName: string
	Title: string,
	Name: string
	LogoLeftTop: string
	LogoRightBottom: string
}

export interface FighterCompareStatWidgetMetadata extends WidgetMetadata {
	RedId: number
	BlueId: number
	RedPhotoUrl: string
	BluePhotoUrl: string
	EventId: number
	FromYear: number
	ToYear: number
	PeriodType: string
	FontFamily: string
	FontColor: string
	Title1: string
	Title2: string
	Title3: string
	Name: string
	LeftLogo: string
	RightLogo: string
	Background: string
}


export interface FighterCompareWidgetMetadata extends WidgetMetadata {
	RedId: number
	BlueId: number
	RedPhotoUrl: string
	BluePhotoUrl: string
	FontFamily: string
	FontColor: string
	Title1: string
	Title2: string
	Name: string
	LeftLogo: string
	RightLogo: string
	Background: string
}


export interface OnlineTextWidgetMetadata extends WidgetMetadata {
	Background: string
	FightId: number
	FontFamily: string
	FontColor: string
	PhotoUrl: string
	Name: string
	LogoLeftTop: string
	LogoRightBottom: string
}


export interface FighterCardWidgetMetadata extends WidgetMetadata {
	FighterId: number
	PhotoUrl: string
	FromYear: number
	ToYear: number
	FontFamily: string
	FontColor: string
	Title1: string
	Name: string
	Logo: string
	Background: string
}

export interface TrainerStat {
	StudentCount: number,
	WorldChampions: number,
	EuroMedalist: number,
	WorldMedalist: number,
	RUMedalist: number,

	SP: number
	HMS: number
	IMS: number,
	CIS: number,
	Adult1: number,
	Adult2: number,
	Adult3: number,
	Youth1: number,
	Youth2: number,
	Youth3: number
}

export interface RegionStat {
	SportClubCount: number,
	TrainersCount: number,
	Rating: number,
	StudentCount: number,
	WorldChampions: number,
	RUMedalist: number,
	EuroMedalist: number,

	SP: number
	HMS: number
	IMS: number,
	CIS: number,
	Adult1: number,
	Adult2: number,
	Adult3: number,
	Youth1: number,
	Youth2: number,
	Youth3: number
}

export interface VideoFile {
	Id: number
	FileId: string
	Name: string
	EventId: number
	BattleId: number
	AthleteId: number
	Created: string
}
